import React from 'react';
import InputImagenCV from './controladorVista/inputImagenDocumentoCV';
import { IInputImagenDocumentoCVProps } from './interfaces';

const InputImagen: React.FunctionComponent<IInputImagenDocumentoCVProps> = (props) => <InputImagenCV {...props} />;

export default InputImagen;
